/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useParams } from 'react-router-dom';
import {
  actions as feedActions,
} from 'Slice/FeedActivitiesSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  Suspense, useEffect, useMemo, useState,
} from 'react';
import { Filter } from 'Types/FilterTypes';
import { FilterObject } from 'Types/GlobalTypes';
import { TOOLTIP_ACCOUNTACTIVITY, VIDEO_ACCOUNTACTIVITY } from 'Utils/Constants';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import { Waypoint } from 'react-waypoint';
import AllTab from './AllTab';
import NewsTab from './NewsTab';
import HeatMapProgress from '../../common/components/HeatMapProgress';
import ThunderActivityIcon from '../../common/assets/svgIcons/ThunderActivityIcon';

type TabsInterface = {
  [key: string]: JSX.Element | string
};

type Params = {
  section: string
};

const data = [
  {
    name: 'string',
    color: 'string',
    percentage: 'string',
    start: 'string',
    end: 'string',
  },
];

type Nav = {
  name: string
  isShow: boolean
};

type Props = {
  onChangeGetFilters?: (obj: FilterObject) => void
  onFilterChanged?: () => void
  filters?: Filter[]
  selectAll?: boolean
  filterChanged?: boolean
  navUpdated: Nav[]
  listView?: boolean,
} & typeof defaultProps;

const defaultProps = {
  onChangeGetFilters: (obj: FilterObject) => { },
  onFilterChanged: () => { },
  filters: {},
  selectAll: false,
  filterChanged: false,
  listView: false,
};

const AccountActivitySection = function AccountActivitySection(props: Props) {
  const { navUpdated, listView } = props;
  const { section } = useParams<Params>();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      page: 1,
    };
    dispatch(feedActions.getNewsActivites(params));
    return () => { dispatch(feedActions.setActivitiesLoaded(false)); };
  }, []);

  const cData = useSelector(selectData);

  const tabs: TabsInterface = {
    gilroy: <NewsTab listview={listView} />,
    spotlight: <NewsTab listview={listView} />,
    news: <NewsTab listview={listView} />,
  };

  const tabsTitle: TabsInterface = {
    spotlight: 'Sales Trigger',
    news: 'Sales Trigger',
    gilroy: 'Sales Trigger',
  };

  const navLength = () => navUpdated.some((n) => n.isShow);
  const navValue = () => navUpdated.filter((n) => n.isShow).map((v) => v.name);
  const tabTitleDrop = tabsTitle[section?.toLowerCase() || navValue()[0]];
  const onEnter = () => {
    if (section === 'social') {
      dispatch(certificationActions.certificationAction({
        type: 'account_social_tab',
        source: 'account_activity',
        data: cData,
      }));
    }
  };

  return (
    <div id="tabs-details" className="account-activity-wrapper">
      <Waypoint onEnter={onEnter}>
        <div className="heading-inner-page tabs-placeholder">
          <div className="head-wrap">
            {navLength()
              ? (
                <div className="d-flex align-items-center">
                  <Suspense
                    fallback={
                      <div />
                    }
                  >
                    <ThunderActivityIcon />
                  </Suspense>
                  <h1 className="heading d-flex align-items-center ">
                    {tabTitleDrop}
                    <HeadingWithToolTip
                      heightIcon={tabTitleDrop === 'Social' ? '20px' : '13px'}
                      heightIconSm={tabTitleDrop === 'Social' ? '20px' : '16px'}
                      heightIconXSm={tabTitleDrop === 'Social' ? '20px' : '16px'}
                      toolTipText={TOOLTIP_ACCOUNTACTIVITY}
                      videoLink={VIDEO_ACCOUNTACTIVITY}
                    />
                  </h1>
                </div>
              ) : null}
          </div>
        </div>
      </Waypoint>
      <Suspense
        fallback={
          <div />
        }
      >
        <HeatMapProgress pulse={data} />
      </Suspense>
      {
        useMemo(
          () => (
            <div>{tabs[section?.toLowerCase() || navValue()[0]]}</div>
          ),
          [section, listView],
        )
      }
    </div>
  );
};

AccountActivitySection.defaultProps = defaultProps;
export default AccountActivitySection;
